import { i18n } from "@/i18n"
import en from "@/i18n/locales/en/auth.json"
import fr from "@/i18n/locales/fr/auth.json"

/**
 * The `auth` namespace, loaded with the auth screens rather than in the shell
 * (LLD §10). Its own chunk, which index.html preloads beside the sign-in
 * screen (vite.config.ts), so React's takeover of the static first paint does
 * not wait for it.
 *
 * The sign-in chunk starts loading when the route table does, which can be
 * before `initI18n()` has finished: the bundles are added once i18next is
 * ready.
 */
export async function registerAuthNamespace(): Promise<void> {
  if (!i18n.isInitialized) {
    await new Promise<void>((resolve) => {
      i18n.on("initialized", () => {
        resolve()
      })
    })
  }
  if (!i18n.hasResourceBundle("en", "auth")) i18n.addResourceBundle("en", "auth", en)
  if (!i18n.hasResourceBundle("fr", "auth")) i18n.addResourceBundle("fr", "auth", fr)
}
